import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogs } from '../data/blogsData';
import { FAQitem } from '../utils/FAQitem';
import { useNavigate } from 'react-router-dom';

const Blog3 = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const blogData = blogs.find(b => b.id === 3);

    return (
        <div className="bg-white">
            <div className="max-w-[1180px] mx-auto px-5 py-5">
                <button
                    onClick={() => navigate('/blogs')}
                    className="inline-flex fixed top-30 bg-black p-1 rounded-full hover:scale-110 items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors text-sm font-medium mb-5"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="19" y1="12" x2="5" y2="12"></line>
                        <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                </button>
            </div>

            <div className="max-w-[1180px] mx-auto px-5 pb-[70px] flex flex-col lg:flex-row items-start gap-10">
                <main className="flex-1 max-w-full lg:max-w-[760px] min-w-0">
                    {/* <div className="text-xs text-gray-400 mb-[18px]">
                        Car Care &nbsp;›&nbsp; Road Trip Preparation
                    </div> */}

                    <section className="pb-6 border-b border-gray-200 mb-7">
                        <h1 className="text-3xl md:text-4xl lg:text-[42px] leading-[1.15] mb-3.5 text-gray-900 font-bold tracking-tight">
                            
                        </h1>
                        <h1 className="text-3xl md:text-4xl lg:text-[42px] leading-[1.15] mb-3.5 text-gray-900 font-bold tracking-tight">
                            Pre-Road Trip Car Inspection Checklist: 10 Things to Check Before a Long Drive
                        </h1>

                        <p className="text-lg md:text-xl text-gray-600 mb-[18px]">
                            Check your vehicle before a long drive with this simple pre-road trip car
                            inspection checklist to improve safety, avoid breakdowns, and travel with confidence.
                        </p>

                        <div className="text-sm text-gray-500">
                            By <strong className="text-gray-900">DriveWithDash Editorial Team</strong>
                            &nbsp;|&nbsp; Updated March 2026 &nbsp;|&nbsp; 10 min read
                        </div>
                    </section>

                    <figure className="mb-8">
                        <img
                            src="/blogs/3_1.jpeg"
                            alt="Driver checking a car before a long road trip"
                            title="Pre-Road Trip Car Inspection Checklist"
                            className="w-full h-auto block border border-gray-300 rounded-xl"
                        />
                        <figcaption className="text-xs text-gray-400 mt-2">
                            Featured image: road_trip_car_inspection_featured.png
                        </figcaption>
                    </figure>

                    <nav className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-8">
                        <div className="text-base font-bold text-gray-900 mb-2.5">
                            In this article
                        </div>

                        <ul className="m-0 pl-[18px] text-gray-700 list-disc space-y-1">
                            <li><a href="#quick-answer" className="text-gray-900 no-underline hover:underline">Quick answer</a></li>
                            <li><a href="#inspection-table" className="text-gray-900 no-underline hover:underline">Road trip checklist summary</a></li>
                            <li><a href="#why-it-matters" className="text-gray-900 no-underline hover:underline">Why pre-trip inspection matters</a></li>
                            <li><a href="#check-1" className="text-gray-900 no-underline hover:underline">1. Engine oil</a></li>
                            <li><a href="#check-2" className="text-gray-900 no-underline hover:underline">2. Tires</a></li>
                            <li><a href="#check-3" className="text-gray-900 no-underline hover:underline">3. Brakes</a></li>
                            <li><a href="#check-4" className="text-gray-900 no-underline hover:underline">4. Battery</a></li>
                            <li><a href="#check-5" className="text-gray-900 no-underline hover:underline">5. Coolant</a></li>
                            <li><a href="#check-6" className="text-gray-900 no-underline hover:underline">6. Lights</a></li>
                            <li><a href="#check-7" className="text-gray-900 no-underline hover:underline">7. Wipers and washer fluid</a></li>
                            <li><a href="#check-8" className="text-gray-900 no-underline hover:underline">8. All major fluids</a></li>
                            <li><a href="#check-9" className="text-gray-900 no-underline hover:underline">9. Belts and hoses</a></li>
                            <li><a href="#check-10" className="text-gray-900 no-underline hover:underline">10. Emergency kit and documents</a></li>
                            <li><a href="#dash-section" className="text-gray-900 no-underline hover:underline">Track trip readiness with CarFido</a></li>
                            <li><a href="#extra-tips" className="text-gray-900 no-underline hover:underline">Extra road trip safety tips</a></li>
                            <li><a href="#faq" className="text-gray-900 no-underline hover:underline">FAQ</a></li>
                        </ul>
                    </nav>

                    <section className="mb-8 overflow-hidden">
                        <p className="mb-[18px]">
                            A long drive can put extra stress on your car, especially if you are traveling
                            in hot weather, carrying luggage, or driving through unfamiliar areas. That is
                            why a pre-road trip car inspection checklist is one of the smartest things you
                            can do before leaving.
                        </p>

                        <p className="mb-[18px]">
                            Many road trip breakdowns happen because of simple issues that could have been
                            caught early, such as low tire pressure, weak batteries, worn brakes, or low
                            fluid levels. Spending a little time checking your vehicle can help prevent
                            bigger problems on the road.
                        </p>

                        <p className="mb-0">
                            This guide covers 10 essential things to check before a long drive so you can
                            improve safety, reduce the chance of delays, and travel with more confidence.
                        </p>
                    </section>

                    <section
                        id="quick-answer"
                        className="mb-9 bg-gray-50 border-l-4 border-gray-900 rounded-lg p-[18px]"
                    >
                        <div className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-2">
                            Quick Answer
                        </div>
                        <p className="m-0 text-gray-900 font-medium">
                            <strong>What should you check before a long road trip?</strong><br />
                            Before a long drive, check engine oil, tire pressure and tread, brakes,
                            battery condition, coolant, lights, windshield wipers, washer fluid,
                            important fluids, belts, hoses, and emergency supplies.
                        </p>
                    </section>

                    <section id="inspection-table" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Road Trip Checklist Summary
                        </h2>

                        <div className="overflow-x-auto border border-gray-200 rounded-xl">
                            <table className="w-full border-collapse bg-white text-sm">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="text-left py-3.5 px-4 border-b border-gray-200 text-gray-900 font-bold">Item to Check</th>
                                        <th className="text-left py-3.5 px-4 border-b border-gray-200 text-gray-900 font-bold">Why It Matters</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Tires, brakes, battery</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Critical for safety and breakdown prevention</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Engine oil, coolant, fluids</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Helps the engine run safely and efficiently</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 border-b border-gray-200 font-medium">Lights, wipers, washer fluid</td>
                                        <td className="py-3.5 px-4 border-b border-gray-200 text-gray-600">Improves visibility and visibility to others</td>
                                    </tr>
                                    <tr className="hover:bg-gray-50 transition-colors">
                                        <td className="py-3.5 px-4 font-medium">Emergency kit and documents</td>
                                        <td className="py-3.5 px-4 text-gray-600">Helps you handle delays or roadside problems</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section id="why-it-matters" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Why a Pre-Trip Car Inspection Matters
                        </h2>

                        <p className="mb-4 text-gray-700">
                            A pre-road trip car inspection checklist helps you find small issues before
                            they become major problems during travel. That can save you time, money,
                            and stress while you are away from home.
                        </p>

                        <p className="mb-5 text-gray-700">
                            Even if your car seems to be running fine, quick checks before a long drive
                            can improve safety and reduce the chance of unexpected roadside trouble.
                        </p>

                        <ul className="pl-6 m-0 space-y-2 text-gray-700 list-disc">
                            <li>Helps prevent breakdowns</li>
                            <li>Improves road safety</li>
                            <li>Reduces repair costs</li>
                            <li>Gives you more confidence during long travel</li>
                        </ul>
                    </section>

                    <figure className="mb-10">
                        <img
                            src="/blogs/3_2.jpeg"
                            alt="Checking engine bay before a long road trip"
                            title="Engine inspection before road trip"
                            className="w-full h-auto block border border-gray-300 rounded-xl"
                        />
                        <figcaption className="text-xs text-gray-400 mt-2">
                            Inline image: road_trip_engine_check.png
                        </figcaption>
                    </figure>

                    <section id="check-1" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            1. Check Engine Oil
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Engine oil keeps internal engine parts lubricated and helps control heat.
                            Low or dirty oil can increase wear and raise the risk of engine trouble during a long drive.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">What to check:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Oil level on the dipstick</li>
                            <li>Oil color and condition</li>
                            <li>Signs of oil leaks under the car</li>
                        </ul>
                    </section>

                    <section id="check-2" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            2. Inspect Tires
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Tires are one of the most important safety checks before a long drive.
                            Poor tire condition can increase the risk of blowouts, poor handling, and fuel waste.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Tire checklist:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Correct tire pressure</li>
                            <li>Adequate tread depth</li>
                            <li>Visible cuts, bulges, or uneven wear</li>
                            <li>Condition of the spare tire</li>
                        </ul>
                    </section>

                    <section id="check-3" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            3. Check the Brakes
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Brakes must be in good condition before any road trip, especially if you may
                            be driving in traffic, mountains, or bad weather.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Watch for signs such as:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Squeaking or grinding noises</li>
                            <li>Soft brake pedal feel</li>
                            <li>Vibration or pulling while braking</li>
                        </ul>
                    </section>

                    <section id="check-4" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            4. Test the Battery
                        </h2>
                        <p className="mb-4 text-gray-700">
                            A weak battery can leave you stranded, especially if you stop often during
                            your trip or use lights, charging ports, and climate controls heavily.
                        </p>
                        <p className="mb-0 text-gray-700">
                            Check for slow starting, corrosion on battery terminals, or signs that the
                            battery is getting old. If in doubt, have it tested before the trip.
                        </p>
                    </section>

                    <section id="check-5" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            5. Check Coolant Level
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Coolant helps regulate engine temperature. Low coolant levels can lead to
                            overheating, which is one of the most common causes of road trip trouble.
                        </p>
                        <p className="mb-0 text-gray-700">
                            Check the coolant reservoir when the engine is cool and look for leaks,
                            low fluid level, or signs of contamination.
                        </p>
                    </section>

                    <section id="check-6" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            6. Test All Exterior Lights
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Working lights are essential for safe driving, especially if your trip includes early morning, nighttime, or rainy conditions.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Check these lights:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Headlights</li>
                            <li>Brake lights</li>
                            <li>Turn signals</li>
                            <li>Hazard lights</li>
                        </ul>
                    </section>

                    <section id="check-7" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            7. Inspect Windshield Wipers and Washer Fluid
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Clear visibility matters on every trip. Worn wiper blades or low washer fluid can become a serious problem if you hit dust, bugs, or sudden rain.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Make sure the blades wipe cleanly and refill washer fluid before leaving.</p>
                    </section>

                    <section id="check-8" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            8. Check All Major Fluids
                        </h2>
                        <p className="mb-4 text-gray-700">
                            In addition to engine oil and coolant, your car relies on several other fluids to operate safely and smoothly.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Check these lights:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Brake fluid</li>
                            <li>Transmission fluid</li>
                            <li>Power steering fluid if applicable</li>
                            <li>Windshield washer fluid</li>
                        </ul>
                    </section>

                    <section id="check-9" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            9. Look at Belts and hoses
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Belts and hoses play a critical role in engine operation and cooling system performance. Cracks, fraying, swelling, or leaks can lead to breakdowns.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">A quick visual inspection can help spot obvious wear before it becomes a bigger problem.</p>
                        
                    </section>

                    <section id="check-10" className="mb-10">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            10. Pack an Emergency Kit and Important Documents
                        </h2>
                        <p className="mb-4 text-gray-700">
                            Even a well-maintained car can face unexpected issues. Carrying basic emergency items
                            makes it easier to handle delays or roadside problems.
                        </p>
                        <p className="mb-2.5 text-gray-900 font-bold">Useful items include:</p>
                        <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                            <li>Jack and lug wrench</li>
                            <li>Flashlight</li>
                            <li>First-aid kit</li>
                            <li>Phone charger</li>
                            <li>Registration, insurance, and roadside assistance details</li>
                        </ul>
                    </section>

                    <section id="dash-section" className="mb-10">
                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
                            <h2 className="text-2xl leading-tight mb-3.5 text-gray-900 font-bold">
                                Track Road Trip Readiness with CarFido
                            </h2>

                            <p className="mb-3.5 text-gray-700">
                                Keeping track of maintenance before a road trip can be difficult, especially
                                if you do not remember when your last service was completed.
                            </p>

                            <p className="mb-3.5 text-gray-700">
                                CarFido helps drivers track service history, understand warning signs, and stay
                                on top of maintenance tasks that matter before a long drive.
                            </p>

                            <p className="mb-2.5 text-gray-900 font-bold">Drivers can ask questions such as:</p>

                            <ul className="pl-6 m-0 space-y-1.5 text-gray-700 list-disc">
                                <li>Is my car ready for a road trip?</li>
                                <li>What should I inspect before a 500-mile drive?</li>
                            </ul>
                        </div>
                    </section>

                    <section id="extra-tips" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Extra Road Trip Safety Tips
                        </h2>

                        <ul className="pl-6 m-0 mb-4 space-y-2 text-gray-700 list-disc">
                            <li>Check weather and road conditions before leaving</li>
                            <li>Plan fuel stops in advance</li>
                            <li>Take breaks every 2–3 hours</li>
                            <li>Avoid driving when tired</li>
                            <li>Keep water and snacks in the car</li>
                        </ul>

                        <p className="mb-0 text-gray-700">
                            A little preparation can make long-distance driving safer, more comfortable,
                            and much less stressful.
                        </p>
                    </section>

                    <section id="faq" className="mb-11 border-t border-gray-200 pt-8">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-5 text-gray-900 font-bold">
                            Frequently Asked Questions
                        </h2>

                        <div className="space-y-1">
                            <FAQitem
                                question="How do I prepare my car for a long road trip?"
                                answer="Prepare your car by checking tires, brakes, engine oil, battery, coolant, lights, wipers, and important fluids. It is also smart to carry emergency supplies."
                            />
                            <FAQitem
                                question="What is the most important thing to check before a long drive?"
                                answer="Tires, brakes, engine oil, coolant, and battery condition are among the most important items because they directly affect safety and reliability."
                            />
                            <FAQitem
                                question="Should I service my car before a road trip?"
                                answer="Yes, especially if your car is due for service or showing any warning signs. Preventive maintenance before travel can help avoid unexpected problems."
                            />
                            <FAQitem
                                question="How often should I inspect my car before a trip?"
                                answer="You should do a basic inspection before every long trip, even if the car is regularly maintained."
                            />
                            <FAQitem
                                question="Can CarFido help with pre-trip vehicle checks?"
                                answer="Yes. CarFido can help you keep track of service history, understand warning signs, and remember which maintenance items to review before a long drive."
                            />
                        </div>
                    </section>

                    <section id="final-thoughts" className="mb-11">
                        <h2 className="text-2xl md:text-3xl lg:text-[31px] leading-tight mb-4 text-gray-900 font-bold">
                            Final Thoughts
                        </h2>

                        <p className="mb-0 text-gray-700">
                           A pre-road trip car inspection checklist is one of the easiest ways to prepare for a safe and smooth journey. Small checks before departure can prevent bigger problems later.
                        </p>

                        <p className="mb-0 text-gray-700">
                           By inspecting key items such as tires, brakes, battery, fluids, and lights, you reduce the risk of delays and unexpected breakdowns.
                        </p>

                        <p className="mb-0 text-gray-700">
                           Before your next long drive, take a few minutes to inspect your vehicle properly. A little preparation can make the whole trip safer and less stressful.
                        </p>
                    </section>

                    {/* Up Next Section */}
                    {/* {blogs[3] && (
                        <div className="mt-20 pt-10 border-t border-gray-100">
                            <span className="text-xs font-bold tracking-widest text-gray-400 uppercase">Up Next</span>
                            <Link to="/off-road-prep/off-road-vehicle-checklist" className="group block mt-4">
                                <h3 className="text-2xl font-bold text-gray-900 group-hover:text-black transition-colors">
                                    {blogs[3].title}
                                </h3>
                                <p className="mt-2 text-gray-500 line-clamp-2">
                                    {blogs[3].excerpt}
                                </p>
                                <div className="mt-4 flex items-center text-black font-bold text-sm">
                                    Read Article
                                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                    </svg>
                                </div>
                            </Link>
                        </div>
                    )} */}
                </main>



                <aside className="w-full lg:w-[300px] lg:flex-[0_0_300px] lg:sticky lg:top-5 self-start space-y-5">
                    <div className="border border-gray-200 rounded-xl bg-white p-5">
                        <div className="text-base font-bold text-gray-900 mb-3">
                            Quick Navigation
                        </div>

                        <ul className="list-none p-0 m-0 space-y-2.5">
                            <li><a href="#quick-answer" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Quick answer </a></li>
                            <li><a href="#inspection-table" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Checklist Summary</a></li>
                            <li><a href="#why-it-matters" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Why it Matters</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Engine Oil</a></li>
                            <li><a href="#check-2" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Tire Check</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Brakes</a></li>
                            <li><a href="#check-2" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Battery</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Coolant</a></li>
                            <li><a href="#check-2" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Lights</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Wipers</a></li>
                            <li><a href="#check-2" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Fluids</a></li>
                            <li><a href="#check-1" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Emergency Kit</a></li>
                            <li><a href="#extra-tips" className="no-underline text-gray-600 hover:text-gray-900 text-sm">Safety Tips</a></li>
                            <li><a href="#faq" className="no-underline text-gray-600 hover:text-gray-900 text-sm">FAQ</a></li>
                        </ul>
                    </div>

                    

                    <div className="border border-gray-200 rounded-xl bg-gray-50 p-5">
                        <div className="text-base font-bold text-gray-900 mb-2.5">
                            Related Reads
                        </div>
                        {(() => {
                            const otherBlogs = blogs.filter(b => b.id !== 3);
                            const startIndex = 3 % otherBlogs.length;
                            return [...otherBlogs.slice(startIndex), ...otherBlogs.slice(0, startIndex)].slice(0, 3);
                        })().map((relatedBlog) => (
                            <Link
                                key={relatedBlog.id}
                                to={relatedBlog.path}
                                className="block no-underline text-gray-900 mb-3 text-sm leading-snug font-medium hover:text-gray-600 transition-colors"
                            >
                                {relatedBlog.title}
                            </Link>
                        ))}
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default Blog3;
